import React from 'react';
import styles from './index.module.less';
import { Modal, Checkbox } from 'antd';
import ListProductImage from '@base/snippets/ListProduct/ListProductImage';
import Iconfont from '@base/lib/Iconfont';
import { IAddOnsInstance } from '@base/product/useAddOns';
import { useTrans } from 'base/utils/i18n';

type AddOnsModalProps = {
    visible: boolean;
    onCancel: () => void;
    addOnsIns: IAddOnsInstance;
}

const AddOnsModal: React.FC<AddOnsModalProps> = props => {
    const {
        visible,
        onCancel,
        addOnsIns: {
            variantAddOns,
            checkedAddOns,
            onChangeCheckedAddOns
        }
    } = props;
    const { t } = useTrans();

    return (
        <Modal
            width={572}
            open={visible}
            onCancel={onCancel}
            footer={false}
            className={styles.modal}
            closeIcon={<Iconfont className="icon-x"/>}
            centered
        >
            <h2 className={styles['modal-title']}>{t('web_product_addons_title')}</h2>

            <Checkbox.Group
                value={checkedAddOns}
                className="block"
                onChange={e => onChangeCheckedAddOns(e as string[])}
            >
                {variantAddOns.map(item => (
                    <Checkbox
                        value={item.variantId}
                        className={styles.item}
                        key={item.variantId}
                        disabled={!item.isStock}
                    >
                        <ListProductImage
                            className={styles.image}
                            key={item.variantId}
                            product={item}
                            imageSize={64}
                            fixed
                            canJump={false}
                        />
                        <div className={styles.info}>
                            <div className={styles.name}>{item.name}</div>
                            <div>+{item.dealPriceExchangeDisplay || item.shopPriceExchangeDisplay}</div>
                        </div>
                    </Checkbox>
                ))}
            </Checkbox.Group>
        </Modal>
    );

};

export default AddOnsModal;
